const productState = [
  {
    id: 1,
    name: "Air Max 270-G",
    img:
      "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/626beac1-c764-4941-b907-db79a20bc5fd/air-max-270-g-golf-shoe-gTpCFg.jpg",
    price: "120",
    color: "White, Grey, Black",
    quantity: 0,
    added: false,
  },
  {
    id: 2,
    name: "Air Max WildCard",
    img:
      "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/dd162e91-f40a-4ffa-91f9-b2d68fd3e9d1/nikecourt-air-max-wildcard-tennis-shoe-zjFXv7.jpg",
    price: "172",
    color: "White, Grey, Black",
    quantity: 0,
    added: false,
  },
  {
    id: 3,
    name: "Premier II FG",
    img:
      "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/9fc9da25-b3b2-4657-b81c-b612827a3e5b/premier-ii-fg-football-boot-KyTwAmPK.jpg",
    price: "145",
    color: "White, Grey, Black, Red, Blue",
    quantity: 0,
    added: false,
  },
  {
    id: 4,
    name: "React Miler",
    img:
      "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/i1-5cc7de3b-2afc-49c2-a1e4-0508997d09e6/react-miler-running-shoe-DnVKQm.jpg",
    price: "168",
    color: "White, Grey, Black, Blue",
    quantity: 0,
    added: false,
  },
  {
    id: 5,
    name: "Air Zoom Vomero-14",
    img:
      "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/f312aa50-4e49-4aef-b87a-1ce33a98a456/air-zoom-vomero-14-running-shoe-r03CSP.jpg",
    price: "192",
    color: "White, Grey, Blue, Brown",
    quantity: 0,
    added: false,
  },
  {
    id: 6,
    name: "KD-13",
    img:
      "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/58303425-b100-41a9-b6aa-dd5264c1bd2f/kd13-basketball-shoe-Bngc7j.jpg",
    price: "138",
    color: "White, Grey, Red",
    quantity: 0,
    added: false,
  },
  {
    id: 7,
    name: "Downshifter-10",
    img:
      "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/e7c94e2d-e35f-4c1b-a8db-20b1563143b9/downshifter-10-running-shoe-QL0NBl.jpg",
    price: "108",
    color: "White,Grey,Black,Red,Blue",
    quantity: 0,
    added: false,
  },
  {
    id: 8,
    name: "Lebron Witness-4",
    img:
      "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/2ccb02b9-bf91-49e5-a77f-4911255c343a/lebron-witness-4-basketball-shoe-NckGlQ.jpg",
    price: "135",
    color: "Black, Blue",
    quantity: 0,
    added: false,
  },
  {
    id: 9,
    name: "Metcon 5",
    img:
      "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/3fa5be68-6865-4852-8cff-3a9ad03b021e/metcon-5-training-shoe-vn0wch.jpg",
    price: "150",
    color: "White, Black",
    quantity: 0,
    added: false,
  },
];

export { productState };